export const prefixed = (action: string) => `branches/${action}`;
